import clsx from 'clsx';
import React from 'react';

interface ITagCapsuleProps {
  value: string;
  color?: string;
  backgroundColor?: string;
  className?: string;
}

const TagCapsule: React.FC<ITagCapsuleProps> = ({
  value,
  color,
  backgroundColor,
  className,
}) => {
  return (
    <span
      className={clsx(
        'font-semibold text-xs py-1 px-3 rounded-full inline-block whitespace-nowrap',
        className
      )}
      style={{
        color: color,
        backgroundColor: backgroundColor,
      }}
    >
      {value}
    </span>
  );
};

export default TagCapsule;
